<template>
	<dv-border-box-12>
		<div class="box">
			<div class="box_title">服务</div>
			<div class="serve">
				<div class="serve_top">
					<div class="serve_top_num">
						<div class="dailil">代理机构<span>183</span>家</div>
						<div class="seniority_bg">
							<img src="@/assets/patent/seniority_bg.png" class="seniority_icon">
							<div class="seniority_content">
								<div class="seniority_rank">
									<div class="title">代理师资格</div>
									<div class="num">
										<countTo :startVal='0' :endVal='Number(1671)' :duration='800'></countTo>名
									</div>
								</div>
								<div class="seniority_rank">
									<div class="title">执业资格</div>
									<div class="num">
										<countTo class="num" :startVal='0' :endVal='Number(821)' :duration='800'></countTo>名
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="serve_top_right">
						<div id="serviceChart" :style="{ width:'100%', height: '100%' }"></div>
					</div>
				</div>
				<dv-decoration-3 :color="['#29C5FF']" class="dv_line"/>
				<div class="organList">
					<div class="organItem" v-for="(item,index) in organList.slice(0,4)" :key="index" @click="toDetail(item)">
						<div class="title">{{item.name}}</div>
						<div class="title">（{{item.nums}}家）</div>
						<img src="@/assets/patent/dv_line1.png" alt="" class="dv_line_1">
					</div>
				</div>
				<div class="organList">
					<div class="organItems" v-for="(item,index) in organList.slice(4)" :key="index" @click="toDetail(item)">
						<div class="title">{{item.name}}</div>
						<div class="title">（{{item.nums}}家）</div>
						<img src="@/assets/patent/dv_line2.png" alt="" class="dv_line_1">
					</div>
				</div>
			</div>
		</div>
	</dv-border-box-12>
</template>

<script>
	import data from '@/assets/organList'
	export default {
		data() {
			return {
				organList:[]
			}
		},
		mounted() {
			this.organList = data
		},
		methods:{
			getData(list){
				for(var i in list){
					list[i].name = list[i].district.split('市')
				}
				this.drawChart5(list);
			},
			// 服务
			drawChart5(list) {
				let myChart = this.$echarts.init(document.getElementById('serviceChart'));
				var option = {
					title: {
						text:'安徽省内代理机构分布',
						show:true,
						left: 'center',
						padding:[20,0],
						textStyle: {
							fontSize:16,
							align: 'center',
							color: '#69C0FF',
							fontWeight:400,
						}
					},					
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'line',
							lineStyle: {
								color: 'red'
							}
						}
					},
					grid: {
						left: '0',
						right: '0',
						top: '30%',
						bottom:'5%',
						containLabel: true
					},
					xAxis: [
						{
							type: 'category',
							data:list.map(item =>item.name[0]),
							axisTick: {
								alignWithLabel: true,
								lengt:6
							},
							axisLabel: {
								interval: 0, //数据过多时不间隔显示名称
								textStyle: {
									color: '#fff',
									fontSize:'10',
								}
							},
						}
					],
					yAxis: [
						{
							show: false, //Y轴坐标线隐藏
							type: 'value',
							axisLabel : {   //Y轴隐藏过后产生留白
								formatter: function(){
									return "";
								}
							}
						}
					],
					color:['#1890FF'],
					series: [
						{
							name: '金额亿元',
							type: 'bar',
							barWidth: '50%', //柱子粗细
							label: { //显示数值
								show: true,
								position: 'inside',
								color: '#fff',
								
							},
							showBackground: true,
							backgroundStyle: {
								color: 'rgba(255,255,255,0.1)',
							},
							data:list.map(item =>item.dljg),
						},
					]
				};
				myChart.setOption(option);
				window.addEventListener("resize", function() {
					myChart.resize();
				});
			},
			// 查看详情
			toDetail(item){
				this.$emit('toManageDetail',2,item)
			},
		}
	}
</script>

<style>
</style>
